import {RefObject, useEffect, useState} from 'react'

export const useRowHovered = (ref: RefObject<HTMLElement>): boolean => {
  const [rowHovered, setRowHovered] = useState(false)
  useEffect(() => {
    if (!ref.current) {
      return () => void 0
    }

    const hover = () => setRowHovered(true)
    const out = () => setRowHovered(false)
    const rowEl = ref.current.closest('.group\\/row')
    rowEl?.addEventListener('mouseover', hover)
    rowEl?.addEventListener('mouseleave', out)
    return () => {
      rowEl?.removeEventListener('mouseover', hover)
      rowEl?.removeEventListener('mouseleave', out)
    }
  }, [ref])
  return rowHovered
}
